import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
// constants
import ROLES from '../../constants/Roles';
import { avatar as avatarColours } from '../../constants/ColourConstants';
// components
import Avatar from 'material-ui/Avatar';
import ContextIconMenu from '../Common/ContextIconMenu';
import { ListItem } from 'material-ui/List';
// icons
import ContactIcon from 'material-ui/svg-icons/social/person';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
// business logic
import ContactActions from '../../actions/ContactActionCreator';

const style = {
    listItem: {
        padding: '2px'
    },
};

const getActions = (row) => [

    {
        link: `/dashboard/contact/${row.id}`,
        label: 'Preview',
        icon: <InfoIcon />
     },
    {
        type:'divider'
    },
    {
        link: `/dashboard/contact/${row.id}/edit`,
        label: 'Edit',
        icon: <EditIcon />,
        condition: {
            roles: [ROLES.ADMIN]
        }
     },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete course',
        deleteAction: ContactActions.delete,
        message: (
            <span>
                Are you sure to delete the contact  "{row.name}" ?
            </span>
        ),
        condition: {
            roles: [ROLES.ADMIN]
        }
    }

];


const ContactListItem  = ({data, actions})  => {

        const infoLink = `/dashboard/contact/${data.id}`;
        return (
            <ListItem
                style={style.listItem}
                leftAvatar={<Link to={infoLink}><Avatar icon={<ContactIcon />} style={avatarColours.default} /></Link>}
                primaryText={<Link to={infoLink} className="primaryText">{data.name}</Link>}
                secondaryText={
                    <Link to={infoLink} className="secondaryText">
                    Tel. <br/>
                    Email: {data.email}
                    </Link>
                }
                secondaryTextLines={2}
                rightIcon={<ContextIconMenu actions={actions || getActions(data)} data={data} />}
            />
        );
};

ContactListItem.propTypes = {
    data:       PropTypes.object,
    actions:    PropTypes.arrayOf(PropTypes.object)
};

export default ContactListItem;
